import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { Button, Flex, Menu, Tooltip } from "antd";
import { useLocation, useNavigate, useParams } from "react-router";
import { ROUTES } from "../../constants/routes.constant";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import EventSteps from "./EventSteps";
import { IconArrowNarrowLeft, IconPencil, IconX } from "@tabler/icons-react";

import EventCard from "./EventCard";
import { getMenuForEventStatus } from "../../utils/eventMenu";
import DeleteEvent from "./DeleteEvent";

import { AuthCheckerHide } from "../AuthChecker";
import React from "react";
import { WorkspaceCheckerHide } from "../WorkspaceChecker";
import { setEditEvent } from "../../store/slices/eventedit.slice";
import {
  isEventSetupReadOnly,
  isEventUnderAdminReview,
} from "../../utils/eventEditAccess";

const SideBar = () => {
  return (
    <div className="border-r custom-sidebar border-gray-200 sticky top-54 left-0 bottom-0 h-full max-h-[calc(100dvh-54.67px)] w-3xs hidden lg:flex flex-col overflow-y-auto bg-white shrink-0">
      <SideBarItem />
    </div>
  );
};

export default SideBar;

export const SideBarItem = ({
  setOpen,
}: {
  setOpen?: Dispatch<SetStateAction<boolean>>;
}) => {
  const { id } = useParams();
  const show = useSelector((state: RootState) => state.eventEdit);
  const dispatch = useDispatch();
  const event = useSelector((store: RootState) => store.event);
  const validation = useSelector((store: RootState) => store.validation);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [validate, setValidate] = useState(false);

  const isSetupPath =
    pathname.includes("/edit-event") ||
    pathname.includes("/add-event-details") ||
    pathname.includes("/add-event-ticket") ||
    pathname.includes("/add-event-custom-form");
  useEffect(() => {
    if (validation?.name === "event" && validation?.check) setValidate(true);
  }, [event]);

  return (
    <>
      {/* Sidebar top actions */}
      <div className="flex items-center justify-between  p-10  border-b border-gray-100">
        <Tooltip title="Back to Events">
          <Button
            variant="filled"
            color="default"
            shape="circle"
            size="small"
            onClick={() => {
              navigate(ROUTES.LIST_EVENT.path);
              if (setOpen) setOpen(false);
            }}
            icon={<IconArrowNarrowLeft size={15} />}
          />
        </Tooltip>
        <WorkspaceCheckerHide>
          <Flex gap={6} align="center">
            {event.status !== "draft" &&
              !isEventSetupReadOnly(event) &&
              (show.editEvent ? (
                <Tooltip title="Cancel Edit">
                  <Button
                    variant="filled"
                    color="default"
                    shape="circle"
                    size="small"
                    onClick={() => {
                      dispatch(setEditEvent({ editEvent: false }));
                      navigate(ROUTES.DASHBOARD.path.replace(":id", id!));
                    }}
                    icon={<IconX size={15} />}
                  />
                </Tooltip>
              ) : (
                !isEventUnderAdminReview(event) && (
                  <Tooltip title="Edit Event">
                    <Button
                      variant="filled"
                      color="blue"
                      shape="circle"
                      size="small"
                      onClick={() => {
                        dispatch(setEditEvent({ editEvent: true }));
                        navigate(ROUTES.EDIT_EVENT.path.replace(":id", id!));
                      }}
                      icon={<IconPencil size={15} />}
                    />
                  </Tooltip>
                )
              ))}
            <DeleteEvent id={id!} child={false} />
          </Flex>
        </WorkspaceCheckerHide>
      </div>

      <EventCard />

      {show.editEvent ||
      isSetupPath ||
      event.status === "draft" ||
      event?.status === "approved" ||
      event.status === "requested" ||
      event.status === "rejected" ? (
        <EventSteps validate={validate} />
      ) : (
        <>
          {getMenuForEventStatus(event.status).map(
            ({ name, icon: Icon, path, access_name, archivedOnly }) => {
              const isActive = pathname === path.replace(":id", event.id!);
              const menuItem = (
                <Menu
                  mode="inline"
                  selectedKeys={isActive ? [name] : []}
                  onClick={() => {
                    if (setOpen) setOpen(false);
                    navigate(path.replace(":id", event.id!));
                  }}
                  style={{ borderInlineEnd: "0px" }}
                >
                  <Menu.Item key={name} icon={<Icon size={15} stroke={1.5} />}>
                    {name}
                  </Menu.Item>
                </Menu>
              );

              return (
                <React.Fragment key={name}>
                  {archivedOnly ? (
                    menuItem
                  ) : (
                    <AuthCheckerHide access_name={access_name}>
                      {menuItem}
                    </AuthCheckerHide>
                  )}
                  {/* <Button
                    type="text"
                    icon={<Icon size={15} stroke={1.5} />}
                    onClick={() => {
                      if (setOpen) setOpen(false);
                      navigate(path.replace(":id", event.id!));
                    }}
                    block
                    className={[
                      "!flex !justify-start !items-center !text-[13px] !rounded-[6px] !h-[36px] !px-[10px]",
                      isActive ? "font-extrabold!" : "",
                    ].join(" ")}
                  >
                    {name}
                  </Button> */}
                </React.Fragment>
              );
            },
          )}
        </>
      )}
    </>
  );
};
